import React from 'react';

import { Stack } from '@/components/layout';
import { Text } from '@/components/ui';
import { STRINGS } from '@/constants/strings';
import type { GuardianCircleMemberStatus } from '@/features/guardian-player/types';
import { createStyles } from '@/hooks';
import { guardianColors, withOpacity } from '@/theme/colors';

const strings = STRINGS.guardianPlayer.guardianCircle.status;

/** Statuses that render a status pill (pending invitations). */
export type BadgeStatus = Extract<GuardianCircleMemberStatus, 'waiting' | 'expired' | 'declined'>;

export function getBadgeStatus(status: GuardianCircleMemberStatus): BadgeStatus | null {
  return status === 'waiting' || status === 'expired' || status === 'declined' ? status : null;
}

const BADGE_CONFIG: Record<BadgeStatus, { label: string; color: string; backgroundColor: string }> =
  {
    waiting: {
      label: strings.waiting,
      color: guardianColors['Primary Color'],
      backgroundColor: withOpacity('#FFCC02', 0.2),
    },
    expired: {
      label: strings.expired,
      color: guardianColors['6'],
      backgroundColor: withOpacity(guardianColors['4'], 0.43),
    },
    declined: {
      label: strings.declined,
      color: guardianColors['6'],
      backgroundColor: withOpacity(guardianColors['4'], 0.43),
    },
  };

type Props = {
  status: BadgeStatus;
};

export default function GuardianCircleStatusBadge({ status }: Props) {
  const styles = useStyles();
  const config = BADGE_CONFIG[status];

  return (
    <Stack style={[styles.badge, { backgroundColor: config.backgroundColor }]}>
      <Text
        variant="Font Guardian App/Subtitle/Subtitle 12 Semibold"
        style={{ color: config.color }}>
        {config.label}
      </Text>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  badge: {
    height: scale(24),
    borderRadius: scale(8),
    borderCurve: 'continuous',
    paddingHorizontal: scale(12),
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
